import React from 'react'
import { connect } from 'react-redux'
import {
  Fade,
} from '@material-ui/core'

import { PHCont } from './styled'
import { StdCard } from 'components'
import { ProcessRow } from './ProcessRow'

const CommentHistory = props => {
  const { contractDetail } = props
  return (
    <React.Fragment>
      {contractDetail && contractDetail.contractComments && contractDetail.contractComments.length>0 &&
      <Fade in={true} timeout={1000}>
        <PHCont>
          <StdCard title="Comment History" style={{ flex: 1 }}>
            {contractDetail &&contractDetail.contractComments&&
              contractDetail.contractComments.map((item, i) => {
                let files = contractDetail.attachments.filter(x=>x.commentId===item.id)
                return <ProcessRow data={item} files={files} />
              })}
          </StdCard>
        </PHCont>
      </Fade>}
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {
    contractDetail: state.contract.contractDetail.data
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CommentHistory)
